module.exports = __webpack_public_path__ + "static/media/palutena_0.6c8c4035.png";